import { ArticleSource, CreateArticleSourceInput } from "../../../api/schema";
import { InputModalBuilder } from "../../../components/form/InputModalBuilder";
import {
  InputFormMode,
  Mutation,
  ValuesVariables,
} from "../../../components/form/InputForm";
import { UserLanguage } from "../../../lang/lang";
import { ArticleViewResponse } from "../helper/graphql";
import { CreateArticleSourceModalKeys } from "./modals";

export interface CreatePartSourceModalProps {
  bundle: {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    mutation: Mutation<
      ArticleSource,
      ValuesVariables<CreateArticleSourceInput>
    >;
    data: ArticleViewResponse | null;
  };
}

export const CreateArticleSourceModal = (props: CreatePartSourceModalProps) => (
  <InputModalBuilder<ArticleSource, ArticleSource, CreateArticleSourceInput>
    {...props.bundle}
    keys={CreateArticleSourceModalKeys(props.bundle.data)}
    texts={UserLanguage().pages.articleSource.actions}
    open={props.bundle.open}
    reformId={["distributor", "article"]}
    mode={InputFormMode.Create}
    resetOnClose
  >
    {(builder) => (
      <div key="create_part">
        {builder.buildCards()}
        {builder.buildField("order_number")}
        {builder.buildField("distributor")}
        {builder.buildField("url")}
        {builder.buildField("moq")}
        {builder.buildField("quantity_scale")}
      </div>
    )}
  </InputModalBuilder>
);
